import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

export const Areas = () => {
  const { t } = useLang();
  return (
    <section className="py-14 md:py-20 border-t border-navy/5" data-testid="areas-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <Overline>{t.areas.overline}</Overline>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.08] tracking-tight text-navy mt-4">
            {t.areas.title}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <ul className="mt-12 flex flex-wrap gap-3">
            {t.areas.items.map((a) => (
              <li
                key={a}
                className="px-5 py-2.5 text-sm text-navy/75 border border-navy/15 rounded-full hover:border-ser-purple hover:text-ser-purple hover:bg-pale-violet transition-colors cursor-default"
              >
                {a}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
